import React, { FC, useState } from 'react'

import { EuiTitle, EuiSpacer, EuiButton, EuiFlexGroup, EuiFlexItem } from '@elastic/eui'

import { MasterCampaignPlanStatus } from 'api/interfaces/MasterCampaignPlan'
import { Persona } from 'api/interfaces/Persona'

import PersonaCard from './PersonaCard'

export interface PersonaListProps {
  masterCampaignPlanStatus: MasterCampaignPlanStatus
  personas: Persona[]
  onEditPersonaClick?: (persona: Persona) => void
  onAddPersonaClick?: () => void
  onReorderPersonasClick?: () => void
  onDeletePersonaClick?: (persona: Persona) => Promise<void>
  onDeletePersonaLoading?: boolean
  showActions?: boolean
}

const PersonaList: FC<PersonaListProps> = ({ masterCampaignPlanStatus, personas, onEditPersonaClick, onAddPersonaClick, onReorderPersonasClick, onDeletePersonaClick, onDeletePersonaLoading = false, showActions = true }) => {
  const sortedPersonas = [...personas].sort((a, b) => a.rank - b.rank)
  const [expandedPersonas, setExpandedPersonas] = useState<Set<number>>(new Set(sortedPersonas.map(p => p.rank)))

  const togglePersona = (rank: number) => {
    const newExpanded = new Set(expandedPersonas)
    if (newExpanded.has(rank)) {
      newExpanded.delete(rank)
    } else {
      newExpanded.add(rank)
    }
    setExpandedPersonas(newExpanded)
  }

  return (
    <div>
      {showActions && masterCampaignPlanStatus !== MasterCampaignPlanStatus.TransferredToDsp && (
        <>
          <EuiFlexGroup alignItems='center' justifyContent='spaceBetween'>
            <EuiFlexItem grow={false} />
            <EuiFlexItem grow={false}>
              <EuiFlexGroup gutterSize='s' responsive={false}>
                <EuiFlexItem grow={false}>
                  <EuiButton size='s' onClick={onAddPersonaClick}>
                    Add Persona
                  </EuiButton>
                </EuiFlexItem>
                {personas.length > 1 && (
                  <EuiFlexItem grow={false}>
                    <EuiButton size='s' onClick={onReorderPersonasClick}>
                      Change Order
                    </EuiButton>
                  </EuiFlexItem>
                )}
              </EuiFlexGroup>
            </EuiFlexItem>
          </EuiFlexGroup>
          <EuiSpacer size='m' />
        </>
      )}

      {sortedPersonas.map((persona, index) => (
        <div key={persona.name}>
          <PersonaCard masterCampaignPlanStatus={masterCampaignPlanStatus} persona={persona} isExpanded={expandedPersonas.has(persona.rank)} onToggle={() => togglePersona(persona.rank)} onEditClick={showActions ? () => onEditPersonaClick?.(persona) : undefined} onDeleteClick={showActions && onDeletePersonaClick ? () => onDeletePersonaClick(persona) : undefined} onDeleteLoading={onDeletePersonaLoading} showActions={showActions} />
          {index < sortedPersonas.length - 1 && <EuiSpacer size='m' />}
        </div>
      ))}
    </div>
  )
}

export default PersonaList
